import { render, staticRenderFns } from "./Progress.vue?vue&type=template&id=5b528634&"
import script from "./Progress.vue?vue&type=script&lang=ts&"
export * from "./Progress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports